import { render, staticRenderFns } from "./monitoring-point.vue?vue&type=template&id=4996397e&"
import script from "./monitoring-point.vue?vue&type=script&lang=js&"
export * from "./monitoring-point.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports